import { render } from "./Dashboard.vue?vue&type=template&id=cbc066ba&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=cbc066ba&scoped=true&lang=css"

import exportComponent from "/Users/ran/Development/temp/invitee-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc066ba"]])

export default __exports__